import NextLink from "next/link";
import type { Route } from "next";
import type { AnchorHTMLAttributes, ReactNode } from "react";

type AtsaLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
  prefetch?: boolean;
  replace?: boolean;
  scroll?: boolean;
  children?: ReactNode;
};

/**
 * Thin wrapper over next/link for the ATSA section. apps/web has
 * `experimental.typedRoutes` enabled, which rejects plain string hrefs. The
 * ATSA pages use internally-consistent string paths (some computed), so we cast
 * to Route once here instead of scattering `as Route` across every link.
 */
export default function Link({ href, ...rest }: AtsaLinkProps) {
  return <NextLink href={href as Route} {...rest} />;
}
